export const SEGMENT_STORAGE_EVENT = 'pwa:segment-storage-change';

export const SEGMENT_STORAGE_KEYS = ['currentBrand', 'currentFaixa', 'currentTier', 'currentGeneric'] as const;

export type SegmentStorageKey = typeof SEGMENT_STORAGE_KEYS[number];

export interface SegmentStorageEventDetail {
  key: SegmentStorageKey;
  newValue: string | null;
}

const INSTALLED_FLAG = '__segmentStorageBridgeInstalled';
const TARGET_KEYS: Set<string> = new Set(SEGMENT_STORAGE_KEYS);

export const installSegmentStorageBridge = (): void => {
  if (typeof window === 'undefined') return;

  const w = window as unknown as Record<string, unknown>;
  if (w[INSTALLED_FLAG]) return;

  const originalSetItem = localStorage.setItem.bind(localStorage);
  const originalRemoveItem = localStorage.removeItem.bind(localStorage);

  localStorage.setItem = (key: string, value: string) => {
    originalSetItem(key, value);
    if (TARGET_KEYS.has(key)) {
      window.dispatchEvent(
        new CustomEvent<SegmentStorageEventDetail>(SEGMENT_STORAGE_EVENT, {
          detail: { key: key as SegmentStorageKey, newValue: value },
        }),
      );
    }
  };

  localStorage.removeItem = (key: string) => {
    originalRemoveItem(key);
    if (TARGET_KEYS.has(key)) {
      window.dispatchEvent(
        new CustomEvent<SegmentStorageEventDetail>(SEGMENT_STORAGE_EVENT, {
          detail: { key: key as SegmentStorageKey, newValue: null },
        }),
      );
    }
  };

  w[INSTALLED_FLAG] = true;
};
